module.exports = __webpack_public_path__ + "media/icons/loading-76c95539.gif";